import React, {PropsWithChildren, useState} from "react";
import styled, {css} from "styled-components";
import {BOX_BORDER_RADIUS_PX} from "../css-global-constants";
import {InputFieldErrorMessageComponent} from "./error-message/input-field-error-message.component";
import {InputFieldLabelComponent} from "./label/input-field-label.component";
import {observer} from "mobx-react";
import {NullableString} from "../../types/nullable-types";



export const InputFieldContainerBox = styled.div<{isInFocus: boolean; hasError: boolean}>`
    display: flex;
    flex-direction: column;
    cursor: pointer;
    border: 1px solid ${props => props.theme.colors.primary};
    border-radius: ${BOX_BORDER_RADIUS_PX};
    padding: 4px 12px 4px 4px;
    width: 100%;
    min-height: 50px;
    line-height: 1.2;
    font-size: ${props => props.theme.fontSize.medium};

    ${
            props => props.hasError
                    ? css`
                      background-color: rgba(${props => props.theme.colors.dangerRgb}, 0.1);
                      border-color: ${props => props.theme.colors.danger};
                      color: ${props => props.theme.colors.danger};
                    `
                    : ''
    }
`

const IconBox = styled.div`
    display: flex;
    align-content: center;
    justify-content: center;
    width: 30px;
    margin: 0 8px 0 8px;
    color: ${props => props.theme.colors.primary};
`

const InputFieldContentBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    color: ${props => props.theme.colors.lightContrast};
    
`

const InputFieldChildrenBox = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`

export const DropDownIndicatorContainerBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    min-height: 20px;
`

const ErrorMessageContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`

interface InputFieldComponentProps extends PropsWithChildren {
    label: string,
    errorMessage: NullableString;
    icon?: React.ReactElement;
    onClick?: () => void;
    renderDropDownIndicator?: () => React.ReactElement | null;
}

export const InputFieldComponent = observer(React.forwardRef<HTMLDivElement, InputFieldComponentProps>((props, ref) => {
    const [isInFocus, setIsInFocus] = useState(false);

    const onFocusHandler = () => {
        setIsInFocus(true);
    }

    const onBlurHandler = () => {
        setIsInFocus(false);
    }

    const renderDropDownIndicator = () => {
        if(props.renderDropDownIndicator) {
            return (
                <DropDownIndicatorContainerBox>
                    {props.renderDropDownIndicator()}
                </DropDownIndicatorContainerBox>
            );
        }
        return null;
    }

    return (
        <InputFieldContainerBox ref={ref}
                                isInFocus={isInFocus}
                                hasError={Boolean(props.errorMessage)}
                                onFocus={onFocusHandler}
                                onBlur={onBlurHandler}
                                onClick={props.onClick}>
            <InputFieldContentBox>
                <IconBox>
                    {props.icon}
                </IconBox>
                <InputFieldChildrenBox>
                    <InputFieldLabelComponent label={props.label}/>
                    {props.children}
                </InputFieldChildrenBox>
                {renderDropDownIndicator()}

            </InputFieldContentBox>
            <ErrorMessageContainer>
                <InputFieldErrorMessageComponent errorMessage={props.errorMessage}/>
            </ErrorMessageContainer>

        </InputFieldContainerBox>
    )
}));
